import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {
  firstNestedSymbolControl,
  flatMap,
  Modul,
  RisikosuchfrageControl,
  UIArtefakt,
  WertelisteElement,
  WertelisteElementKrankheit
} from '../../models/uiArtefakt';
import {
  ErrorService,
  ErrorStateMatcherFailure,
  ErrorStateMatcherNoFailure,
  inOutAnimation,
  ISymbol, Notification, NotificationService,
  StringUtils,
  TranslationService
} from '@lv1871/core';
import {interval, Observable, Subject, Subscription} from 'rxjs';
import {ErrorStateMatcher} from '@angular/material/core';
import {UiUpdateService} from '../../services/ui-update.service';
import {MatDialog} from '@angular/material/dialog';
import {ModulDialogComponent, ModulDialogInput} from '../popupDialog/uivorgang-dialog/modul-dialog.component';
import {WertemengenService} from '../../services/wertemengen.service';
import {filter, map, take, takeWhile, tap} from 'rxjs/operators';
import {EventService} from '../../services/event.service';
import {UIArtefaktTyp} from '../../models/uiArtefaktTyp';
import {UiControl} from '../../models/uiControl';
import {UiModelService} from '../../services/ui-model.service';
import {ValidationService} from '../../services/validation.service';
import {NgForm, NgModel} from '@angular/forms';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {ShellConfigService} from '../../services/shell-config.service';
import {Bereitstellung} from '../../models/bereitstellung';
import {MatSnackBarConfig} from '@angular/material/snack-bar';

@Component({
    selector: 'lv-risikosuchfrage',
    templateUrl: './risikosuchfrage.component.html',
    styleUrls: ['./risikosuchfrage.component.scss'],
    animations: [inOutAnimation],
    providers: [WertemengenService],
    standalone: false
})
export class RisikosuchfrageComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;
  @ViewChild('risikosuchfrageAutoComplete')
  private _inputmodelAutoComplete: NgModel;
  @ViewChild('risikosuchfrageDropdown')
  private _inputmodelDropdown: NgModel;
  @ViewChild('lvHiddenInput', {static: true})
  private _hiddenInputmodel: NgModel;

  public filteredOptions$;
  public selectedItems: WertelisteElementKrankheit[] = [];
  public isSearching: boolean;
  public stateMatcherFormInput: ErrorStateMatcher;
  public model: any;
  public hasInputFocus: boolean;
  public showUntruncatedError: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public showSpinner: boolean;

  private _uiArtefakt: RisikosuchfrageControl;
  private _subscription = Subscription.EMPTY;
  private _uiControlSubscription = Subscription.EMPTY;
  private _modalDialogSubscription = Subscription.EMPTY;
  private _uiControl: UiControl;
  private _editItemClicked$ = new Subject<WertelisteElementKrankheit>();
  private _editItemClickedSubscription$ = Subscription.EMPTY;
  private _uiControlsRequestPendingSubscription$ = Subscription.EMPTY;
  private _pending: boolean;


  constructor(private _uiUpdateService: UiUpdateService, private matDialog: MatDialog,
              private _wertemengenService: WertemengenService,
              private _translationService: TranslationService,
              private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService,
              private _eventService: EventService, private _uiModelService: UiModelService,
              private _errorService: ErrorService, private _notificationService: NotificationService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): RisikosuchfrageControl {
    return this._uiArtefakt;
  }

  public get hiddenInputmodel(): string {
    return !!this.selectedItems.length ? 'valid' : void 0;
  }

  @Input() set uiArtefakt(uiArtefakt: RisikosuchfrageControl) {
    this._uiArtefakt = uiArtefakt;
    if (!!this._uiArtefakt.WertEingabe) {
      const risiken = this._uiArtefakt.WertEingabe as any[];
      if (!!risiken) {
        if (this.selectedItems.length !== risiken.length ||
            this.selectedItems.filter(item =>
                risiken.indexOf(item.WertEingabe) >= 0).length !== risiken.length) {
          this.selectedItems = risiken.map(risiko => ({
            WertEingabe: risiko.id,
            WertAnzeige: risiko.WertAnzeige,
            synonyme: risiko.synonyme,
            ModulID: risiko.ModulID
          } as WertelisteElementKrankheit));
        }
      }
    }
  }

  public set hiddenInputmodel(value: string) {
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  ngOnInit(): void {
    this.filteredOptions$ = this._wertemengenService.filteredOptions$;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this._subscription = this.filteredOptions$.subscribe(_ => this.isSearching = false);
    this._uiControlSubscription =
        this._eventService.uiControls$.subscribe(uiControl => this._uiControl = uiControl);
    this._uiControlsRequestPendingSubscription$ =
        this._eventService.uiControlsRequestPending$.subscribe(pending => this._pending = pending);
    this._editItemClickedSubscription$ = this._editItemClicked$.pipe(
        filter(krankheit => !!krankheit),
        tap((krankheit: WertelisteElementKrankheit) => {
          if (!this._pending) {
            this._openModalDialog(krankheit,
                this._eventService.uiControls$.pipe(
                    map(control => this._findModul(control, krankheit.WertEingabe))),
                false);
          }
        })
    ).subscribe();
    if (this.uiArtefakt.EnumBereitstellung === Bereitstellung.SYNCHRON) {
      this._filter('');
    }
  }

  ngAfterViewInit(): void {
    if (!!this.uiArtefakt.DefaultVorgabeRisikofragenservice) {
      this.setValue(this.uiArtefakt.WertEingabe[0]);
    }

    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if (!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    if (this._uiControlSubscription) {
      this._uiControlSubscription.unsubscribe();
    }
    if (this._modalDialogSubscription) {
      this._modalDialogSubscription.unsubscribe();
    }
    if (this._editItemClickedSubscription$) {
      this._editItemClickedSubscription$.unsubscribe();
    }
  }

  public trackByFn(index, item) {
    return item.id;
  }

  public filterOptions(value: string) {
    this.model = value;
    this._filter(value);
  }

  public setValue(value: string | any) {
    let newValue;
    if (!!this.uiArtefakt.DefaultVorgabeRisikofragenservice && !!value.id) {
      newValue = value;
      newValue.WertEingabe = value.id;
      this.selectedItems = [];
    } else {
      newValue = this.filteredOptions$.getValue().filter(wert => wert.WertAnzeige === value)[0];
    }
    this.model = '';
    if (!!this.selectedItems.filter(item => item.WertAnzeige === newValue.WertAnzeige).length) {
      return;
    }
    this.showSpinner = true;
    this.selectedItems.push(newValue as WertelisteElementKrankheit);
    this.uiArtefakt.WertEingabe = this._computeWertEingabe();

    this._eventService.uiControlsNewst$.pipe(
        take(1),
        filter((control: UiControl) => {
          // Prüfen obs Detailfragen gibt, nur wenn ja wird ein Modaldialog geöffnet
          const modul = this._findModul(control, newValue.WertEingabe).UIArtefakt;
          this.showSpinner = false;
          return !!modul && !!modul.length;
        }),
        tap(_ => {
          const modul$ = this._eventService.uiControls$.pipe(
              map((control: UiControl) => this._findModul(control, newValue.WertEingabe)),
              tap(modul => {
                    if (!modul) {
                      this._errorService.pushErrorMessage('Für die Krankheit "' + newValue.WertAnzeige + '"' +
                          'wurde kein Modul mit ModulID "' + newValue.WertEingabe + '" vom Core bereitgestellt');
                    }
                  }
              ));
          this._openModalDialog(newValue as WertelisteElementKrankheit, modul$, true);
        }),
    ).subscribe();

    this._eventService.uiControls$.pipe(
        take(1),
        map(control => this._findKrankheit(control, newValue.WertEingabe)),
        tap(modul => {
          if (!!modul) {
            !!this.uiArtefakt.UIArtefakt ? this.uiArtefakt.UIArtefakt.push(modul) : this.uiArtefakt.UIArtefakt = [modul];
          }
          this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
        })).subscribe();
  }

  public hasDialog(value: WertelisteElement): Observable<boolean> {
    return this._eventService.uiControls$.pipe(map((control: UiControl) => {
      const modul = this._findModul(control, value.WertEingabe)?.UIArtefakt;
      return !!modul && !!modul.length;
    }));
  }

  public compareObjects(elem1: WertelisteElement, elem2: WertelisteElement): boolean {
    return StringUtils.isNotNull(elem1) && StringUtils.isNotNull(elem2) && elem1.WertEingabe === elem2.WertEingabe;
  }

  public onDeleteItemClicked(element: WertelisteElement) {
    if (!!element.WertEingabe) {
      this.selectedItems = this.selectedItems.filter(item => element.WertEingabe !== item.WertEingabe);
    } else {
      this.selectedItems = this.selectedItems.filter(item => element.WertAnzeige !== item.WertAnzeige);
    }
    this.uiArtefakt.WertEingabe = this._computeWertEingabe();
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  public onEditItemClicked(element: WertelisteElement) {
    if (this._pending) {
      return;
    }
    const krankheit = element as WertelisteElementKrankheit;
    interval(100).pipe(
        filter(_ => !this._pending),
        tap(_ => this._editItemClicked$.next(krankheit)),
        takeWhile(() => this._pending)).subscribe();
  }

  public onBlur() {
    this.hasInputFocus = false;
    this.getError();
    if (!!this._uiArtefakt.ReferenzIdentifikator) {
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  public getError(): string {
    this.stateMatcherFormInput = new ErrorStateMatcherFailure();
    if (this._hiddenInputmodel.errors?.required && this._inputModelTouched() && !this.hasInputFocus) {
      const requiredError = this._translationService.translate('ERRORS.REQUIRED');
      return !!this._uiArtefakt.FehlertextPflichtfeld ?
          this._uiArtefakt.FehlertextPflichtfeld : requiredError;
    }
    if (this._uiArtefakt.UIMeldung && this._uiArtefakt.UIMeldung.length && this._inputModelTouched()) {
      return this._translationService.translate(this._uiArtefakt.UIMeldung[0].Meldungstext);
    }
    this.stateMatcherFormInput = new ErrorStateMatcherNoFailure();
    this.showUntruncatedError = false;
    return null;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  public onFreitextUebernehmenClicked(freitext: string) {
    if (!freitext) {
      this._ngForm.controls[this._uiArtefakt.Identifikator].markAsDirty();
      this._ngForm.controls[this._uiArtefakt.Identifikator].markAsTouched();
      const notification = new Notification(
          'Alert', 'Danger', '',
          this._translationService.translate('ERRORS.EIGENE_MULTISEARCH_ANGABE'), true, null);
      this._notificationService.addNotification(notification);
      return;
    }
    if (this.selectedItems.filter(item => freitext === item.WertAnzeige).length > 0) {
      return;
    }
    const freitextEingabe = {WertEingabe: null, WertAnzeige: freitext, ModulID: null};
    this.selectedItems.push(freitextEingabe as WertelisteElementKrankheit);
    this.uiArtefakt.WertEingabe = this._computeWertEingabe();
    this.model = '';
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  private _inputModelTouched(): boolean {
    if (this._uiArtefakt.RisikosuchfrageComponent === 'AutoComplete' || !this._uiArtefakt.RisikosuchfrageComponent) {
      return this._inputmodelAutoComplete.touched;
    }
    return this._inputmodelDropdown.touched;
  }

  private _getSnackBarConfig(): MatSnackBarConfig {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 4000;
    return config;
  }

  private _openModalDialog(itemToEdit: WertelisteElementKrankheit,
                           modul$: Observable<UIArtefakt>,
                           newEntry: boolean) {
    const prevControlDeepCopy = JSON.parse(JSON.stringify(this._uiControl));
    this._modalDialogSubscription = this.matDialog.open<ModulDialogComponent, ModulDialogInput, boolean>(ModulDialogComponent, {
      panelClass: 'lv-modal-dialog',
      data: {item: itemToEdit, modul$} as ModulDialogInput,
      disableClose: true,
      autoFocus: false
    }).afterClosed().subscribe(success => {
      if (this._uiArtefakt.RisikosuchfrageComponent === 'AutoComplete' || !this._uiArtefakt.RisikosuchfrageComponent) {
        this.filteredOptions$.next([]);
      }
      if (!success) {
        // reset to previous state
        if (newEntry) {
          this.selectedItems = this.selectedItems.filter(item => itemToEdit.WertEingabe !== item.WertEingabe);
          this.uiArtefakt.WertEingabe = this._computeWertEingabe();
          flatMap(prevControlDeepCopy.uiVorgang.UIArtefakt).filter(artefakt => artefakt.Identifikator === this._uiArtefakt.Identifikator)
              .forEach(artefakt => artefakt.WertEingabe = this._computeWertEingabe());
        }
        this._uiModelService.requestUiControl(prevControlDeepCopy).subscribe();
      } else {
        this._uiModelService.requestUiControl(this._uiControl).subscribe();
      }
    });
  }

  private _findModul(control: UiControl, modulId: string): UIArtefakt | undefined {
    if (!modulId) {
      return undefined;
    }
    const artefaktMatch = flatMap(control?.uiVorgang?.UIArtefakt)
        .filter(artefakt => artefakt.Identifikator === this._uiArtefakt.Identifikator);
    if (artefaktMatch.length === 0) {
      return undefined;
    }
    return artefaktMatch[0]
        .UIArtefakt?.filter(artefakt => artefakt.UIArtefakttyp === UIArtefaktTyp.MODUL)
        .filter(artefakt => (artefakt as Modul).ModulID === modulId)[0];
  }

  private _findKrankheit(control: UiControl, modulId: string): UIArtefakt | undefined {
    if (!modulId) {
      return undefined;
    }
    return (flatMap(control?.uiVorgang?.UIArtefakt)
        .filter(artefakt => artefakt.UIArtefakttyp === this._uiArtefakt.UIArtefakttyp &&
            artefakt.Identifikator !== this._uiArtefakt.Identifikator)[0])?.UIArtefakt?.filter(artefakt =>
        artefakt.UIArtefakttyp === UIArtefaktTyp.MODUL)
        .filter(artefakt => (artefakt as Modul).ModulID === modulId)[0];
  }

  private _computeWertEingabe() {
    return this.selectedItems.map(item => ({
      id: item.WertEingabe,
      WertAnzeige: item.WertAnzeige,
      ModulID: item.ModulID,
      synonyme: item.synonyme
    }));
  }

  private _filter(value: string) {
    this.isSearching = this._wertemengenService.filterWertemenge(this.uiArtefakt, value, this.selectedItems.map(item => item.WertEingabe));
  }
}
